import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Adds a buyer agent to a simulation, including one that's running. Body is
 * one buyerContacts entry: `{ name, title, persona, email? }`.
 * `aiServiceJoinTriggered: false` with no `aiServiceError` is normal (the
 * simulation wasn't running) — the buyer starts on the next start/retrigger.
 * Only a populated `aiServiceError` is a real failure.
 */
const addSimulationBuyer = (simulationId, contact, callback, errorCallback) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/admin/simulations/${simulationId}/agents`,
            contact,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200 || response.status === 201) {
            if (typeof callback === 'function') callback(response?.data);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to add buyer');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(e?.response?.data?.message || 'Failed to add buyer');
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to add buyer');
    }
  };
};

export default addSimulationBuyer;
